export default __webpack_public_path__ + "static/AffordableMobile-dbb6c27e80cdcae85dca2bc8de925e1c.png";